module.exports = __webpack_public_path__ + "img/main-mob.f7864484.webp";